
export default function ProcessOverview() {
  const processes = [
    {
      step: "01",
      title: "Waste Collection",
      description: "We collect organic waste from restaurants, markets, and agricultural sources, turning waste into opportunity.",
      icon: "ri-delete-bin-line",
      image: "https://public.readdy.ai/ai/img_res/992b5a1f8ee12571b4f89f678cf1a75f.jpg"
    },
    {
      step: "02", 
      title: "BSF Larvae Farming",
      description: "Our Black Soldier Fly larvae efficiently convert organic waste into valuable biomass through natural processes.",
      icon: "ri-bug-line",
      image: "https://readdy.ai/api/search-image?query=Black%20Soldier%20Fly%20larvae%20farming%20operation%2C%20BSF%20larvae%20feeding%20on%20organic%20waste%20in%20controlled%20environment%2C%20modern%20insect%20farming%20facility%2C%20sustainable%20protein%20production%2C%20clean%20agricultural%20technology%20setup&width=400&height=300&seq=bsf-larvae&orientation=landscape"
    },
    {
      step: "03",
      title: "Processing & Production", 
      description: "We process mature larvae into high-quality protein meal, oil, and convert waste into nutrient-rich organic fertilizer.",
      icon: "ri-settings-3-line",
      image: "https://readdy.ai/api/search-image?query=BSF%20processing%20facility%20with%20modern%20equipment%20for%20protein%20meal%20and%20oil%20extraction%2C%20clean%20industrial%20processing%20plant%2C%20sustainable%20agriculture%20technology%2C%20quality%20control%20and%20packaging%20operations&width=400&height=300&seq=bsf-processing&orientation=landscape"
    },
    {
      step: "04",
      title: "Market Distribution",
      description: "Our products reach livestock, poultry, aquaculture farmers, and agricultural communities across Ghana and beyond.",
      icon: "ri-truck-line", 
      image: "https://readdy.ai/api/search-image?query=Agricultural%20product%20distribution%20and%20delivery%20trucks%2C%20farmers%20receiving%20BSF%20protein%20feed%20and%20organic%20fertilizer%2C%20rural%20and%20urban%20agricultural%20markets%2C%20sustainable%20farming%20community%2C%20African%20agricultural%20supply%20chain&width=400&height=300&seq=market-distribution&orientation=landscape"
    }
  ];

  return (
    <section id="process-overview" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Circular Economy Process
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From farming to production and training, we are committed to promoting circular economy practices 
            that protect the environment while boosting food security.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {processes.map((process, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative h-48">
                <img 
                  src={process.image}
                  alt={process.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4 bg-green-600 text-white w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg">
                  {process.step}
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4">
                    <i className={`${process.icon} text-green-600 text-xl`}></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">{process.title}</h3>
                </div>
                
                <p className="text-gray-600 leading-relaxed">{process.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-green-50 rounded-xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Innovation, Sustainability, and Empowerment
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              At MY AVA Farms, we believe in innovation, sustainability, and empowering farmers with the knowledge 
              and tools to build a greener future. Our comprehensive approach ensures environmental protection 
              while creating economic opportunities for communities.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
